module.exports = __webpack_public_path__ + "assets/img/dbcf807caf561efdfbc2ea5effa7e14c.svg";